var React = require('react');

function BlogSquiggle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M267.884 91.1066C244.065 76.0822 217.196 61.8899 189.407 56.2378C165.673 51.4106 157.503 59.4731 169.945 80.7451C178.856 95.9799 189.109 110.726 199.858 124.714C200.83 125.979 212.325 137.209 211.481 140.301C210.057 145.524 159.052 128.743 155.889 127.958C148.63 126.155 136.556 121.735 128.589 123.002C119.495 124.449 135.168 146.28 135.617 146.969C141.737 156.375 218.595 247.578 216.707 248.962C209.72 254.086 181.156 240.083 175.982 238.15C147.997 227.698 120.883 214.664 92.5489 205.174C74.847 199.244 44.1421 188.943 32.7223 209.498","strokeWidth":"33.2569","strokeLinecap":"round","strokeLinejoin":"round"}));
}

BlogSquiggle.defaultProps = {"width":"345","height":"345","viewBox":"0 0 345 345","fill":"none"};

module.exports = BlogSquiggle;

BlogSquiggle.default = BlogSquiggle;
